

$('.js-btn-close-alert').on('click', function() {
    let $cookieName = $(this).closest('.site-alert, .pr-alert').first().data('cookieName');
    
    $(this).closest('.site-alert, .pr-alert').slideUp('fast', function() {
        $(this).remove();
    });
    $('.site-header').animate({
        top: 0
    }, 250);
    
    createCookie($cookieName, true, 60);

});